module.exports = __webpack_public_path__ + "static/media/history-calendar.c4be0f32.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/history-calendar.svg
// module id = 862
// module chunks = 7